// © Microsoft Corporation. All rights reserved.

import { enums } from "./enums";

function getParameter(key, defaultValue = null) {
    return getHashParameter(key) || getQueryParameter(key) || defaultValue;
}
function getQueryParameter (key) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    const valueList = [];  // to support multiple parameters with the same key
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0].toLowerCase() == key.toLowerCase()) {
            valueList.push(pair[1]);
        }
    }
    if (valueList.length > 0) {
        return valueList.map(v => decodeURIComponent(v || "")).join(",");
    }
    return null;
}
function getHashParameter(key) {
    const query = window.location.hash.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0].toLowerCase() == key.toLowerCase()) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}
function generateQueryStringByKeyVals(keyVals) {
    return (keyVals && Object.keys(keyVals).length > 0) ? "?" + Object.keys(keyVals).map(function (key) {
        const values = keyVals[key].split(",");
        return values.map(value => {
            if (!value) {  // query parameter without a value
                return key;
            }
            return `${key}=${encodeURIComponent(value)}`;
        }).join("&");
    }).join("&") : "";
}
function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}
function getExternalURL(externalURL: string, market?: string, hasSectionIndicator?: string) {
    const forwardableParameters = ["fdhead", "item", "rt", "theme", "ocid", "env", "oneservice_enable_ppe"];
    const queryParams = {};
    forwardableParameters.map(x => {
        const val = getQueryParameter(x);
        if (val !== null) {
            queryParams[x] = val;
        }
    });
    const queryString = generateQueryStringByKeyVals(queryParams);
    if (market && externalURL.indexOf("/en-us/") > 0) {
        externalURL = externalURL.replace("/en-us/", `/${market}/`);
    }
    if (window.location.origin.indexOf("://int.msn.com") > 0 && externalURL.indexOf("://www.msn.com") > 0) {
        externalURL = externalURL.replace("://www.msn.com", "://int.msn.com");
    }
    const segments = [externalURL];
    if (queryString && externalURL.indexOf("?") != -1) {
        segments.push(`&${queryString.substring(1)}`);
    } else if (queryString) {
        segments.push(queryString);
    }
    segments.push(hasSectionIndicator ? `#comments&commentId=${hasSectionIndicator}` : "");
    return segments.join("");
}
function commentsSectionIndicatorExist() {
    return window.location.hash.includes("comments");
}

function getSubscriptionManagementTabUrl(market) {
    return getExternalURL(`${enums.externalUrls.profilePage}me`, market)+"#subscriptions";
}

export {getParameter, generateQueryStringByKeyVals, decodeHtml, getExternalURL, commentsSectionIndicatorExist, getSubscriptionManagementTabUrl};